import { useUserStore } from '@/js/store/quests/dashboard/UserStore';

/**
 * Checks if scroll-to-top should be prevented.
 * Returns true if game is active AND URL contains a hash fragment.
 * This prevents scroll-to-top from overriding hash-based scrolling.
 * @param hash - Optional hash string (from route.to.hash). If not provided, uses window.location.hash
 */
export const shouldPreventScrollToTop = (hash?: string): boolean => {
    const userStore = useUserStore();
    // Check both store state and DOM class (server-side detection)
    const isGameActiveFromStore = !!userStore.activeUserRoundData && !userStore.isLoadingActiveUserRoundData;
    const isGameActiveFromDOM = document.body.classList.contains('game-active');
    const isGameActive = isGameActiveFromStore || isGameActiveFromDOM;
    const hasHash = hash ? !!hash : !!window.location.hash;
    const result = isGameActive && hasHash;

    return result;
};
